/**
 * simple: just shows the label and time
 * detailed: shows the label, time, price range and meal type
 */
export enum MEAL_PERIOD_LAYOUT {
    simple,
    detailed
}
